var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrToolBar',{attrs:{"configFilter":_vm.configFilter,"addlFilter":_vm.addlFilter},on:{"search":_vm.buscar},scopedSlots:_vm._u([{key:"selectTypePagamentos",fn:function(){return [_vm._t("select")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }